var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"month-view-cal split-icon-header",attrs:{"src":_vm.addChatIcon,"alt":"img"},on:{"click":function($event){$event.preventDefault();return _vm.click($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }